"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CameraOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M19.87 7l1.22 2 .58 1H28v15H4V10h6.33l.58-1 1.22-2h7.74m0-2h-7.74a2 2 0 00-1.71 1L9.2 8H7a1 1 0 00-2 0H4a2 2 0 00-2 2v15a2 2 0 002 2h24a2 2 0 002-2V10a2 2 0 00-2-2h-5.2l-1.22-2a2 2 0 00-1.71-1z"/><path d="M26 11a1 1 0 101 1 1 1 0 00-1-1zM16 12a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7 7 7 0 00-7-7z"/>';
var CameraOutlineSVG = function CameraOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.CameraOutlineSVG = CameraOutlineSVG;
CameraOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CameraOutlineSVG);
exports.default = _default;